import { trans } from '@spotahome/soyuz/client';
import { DSIcon } from '@spotahome/ui-library/base';

import { useSwitchToAgentic } from './useSwitchToAgentic';

import './AgenticEntryFab.scss';

// Mobile entry point into agentic search. Lives in the bottom-centre slot the
// save-alert FAB used to occupy on classic search (the alert moves into the
// exposed-filters bar when the AgenticSearch experiment is on). Branded with
// the home agentic-input chip gradient + the sparkles icon so it reads as the
// AI experience, not another view of the same search. Reuses the existing
// `marketplace.agentic.searchMode.assistant` label.
export const AgenticEntryFab = () => {
  const switchToAgentic = useSwitchToAgentic('switcher_mobile');
  return (
    <button
      type="button"
      className="sah-agentic-fab"
      onClick={switchToAgentic}
      data-test="agentic-entry-fab"
    >
      <span className="sah-agentic-fab__ai">AI</span>
      <DSIcon name="auto_awesome" size="s" className="sah-agentic-fab__icon" />
      <span className="sah-agentic-fab__label">
        {trans('marketplace.agentic.searchMode.assistant')}
      </span>
    </button>
  );
};

export default AgenticEntryFab;
